import { Button, Typography } from '@mui/material';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { FinishedLogo, StyledFinishedScreen } from './styles';

export default function ThirdPartyComplianceCheckFailedScreen() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <StyledFinishedScreen>
      <FinishedLogo />
      <Typography variant="h2" textAlign="center" mb={2}>
        {t('createNewAccount.thirdPartyComplianceCheckFailed.header')}
      </Typography>
      <Typography variant="body2" textAlign="center" mb={4}>
        {t('createNewAccount.thirdPartyComplianceCheckFailed.body')}
      </Typography>
      <Button fullWidth onClick={onBackToSignIn} variant="contained">
        {t(
          'createNewAccount.thirdPartyComplianceCheckFailed.button.backToLogin',
        )}
      </Button>
    </StyledFinishedScreen>
  );
}
